import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=1700626e&scoped=true"
import script from "./Process.vue?vue&type=script&lang=js"
export * from "./Process.vue?vue&type=script&lang=js"
import style0 from "./Process.vue?vue&type=style&index=0&id=1700626e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1700626e",
  null
  
)

export default component.exports